module.exports = __webpack_public_path__ + "img/tokenz.2c04d2ae.png";